import { JobSummaryAdjustment } from './JobSummaryAdjustment';

/**
 * EndOfDay Component
 *
 * Route-level wrapper for the end-of-day job summary screen. Renders
 * {@link JobSummaryAdjustment}, which sources everything it needs from the
 * route params and the Redux store, so this wrapper takes no props.
 */
const EndOfDay = () => {
  return <JobSummaryAdjustment />;
};

export default EndOfDay;
